import * as ActionType from 'utils/ActionType';

const type = {
  INIT: 'INIT',
  SET_LIST: 'SET_LIST',
  SET_PAGE_SIZE: 'SET_PAGE_SIZE',
  SET_PAGE_NUM: 'SET_PAGE_NUM',
  SET_LIMIT_TIME_LIST: 'SET_LIMIT_TIME_LIST',
  SET_RECOMMEND_LIST: 'SET_RECOMMEND_LIST',
  SET_KEYWORD: 'SET_KEYWORD'
};

ActionType.handleType({ type, namespace: 'sec-kill/' });

export default type;
